var DefaultGuardPolicy = /** @class */ (function () {
    function DefaultGuardPolicy(role, resourceName, action) {
        this.role = role;
        this.resourceName = resourceName;
        this.action = action;
    }
    DefaultGuardPolicy.prototype.toJS = function () {
        return {
            subject: { role: this.role },
            resource: { name: this.resourceName },
            action: this.action
        };
    };
    return DefaultGuardPolicy;
}());
export { DefaultGuardPolicy };
//# sourceMappingURL=DefaultGuardPolicy.js.map